import { Injectable } from '@angular/core';
import { filter, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

interface BroadcastMessage {
  type: BROADCAST_TYPE;
  location: string;
}

export enum BROADCAST_TYPE {
  WorkspaceOpened,
  SameWorkspaceDetected,
}

@Injectable({ providedIn: 'root' })
export class BroadcastChannelService {
  private broadcastChannel = new BroadcastChannel('notifications');
  private onMessage$ = new Subject<MessageEvent['data']>();
  private workspaceOpenedMessageSent = false;

  constructor() {
    this.broadcastChannel.onmessage = (message: MessageEvent) => {
      this.onMessage$.next(message.data);
    };
  }

  postMessage(message: BroadcastMessage) {
    this.broadcastChannel.postMessage(message);
  }

  getLocationByType$(type: BROADCAST_TYPE) {
    return this.onMessage$.pipe(
      filter((data: BroadcastMessage) => data.type === type),
      map((data: BroadcastMessage) => data.location),
    );
  }

  notifyWorkspaceOpened() {
    if (this.workspaceOpenedMessageSent) {
      return;
    }

    this.postMessage({
      type: BROADCAST_TYPE.WorkspaceOpened,
      location: window.location.href,
    });

    this.workspaceOpenedMessageSent = true;
  }
}
